'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hoursFromNow;


// WEBPACK FOOTER //
// ./~/sugar-date/number/hoursFromNow.js